var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","title":_vm.title},on:{"click":_vm.action}},[_c('v-icon',{attrs:{"color":_vm.isActive() ? 'black' : ''}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }